import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Left,
  Right,
  Title,
  Description,
  Image,
  Button,
  ButtonInverted,
  ImageContainer,
  PlayOutlineIcon,
} from 'pages/TheFlow/Steps/StepBox/styles';
import ContainerVideoThumb from 'pages/TheFlow/Steps/StepBox/VideoThumb';

const StepBox = ({
  title,
  description,
  imageUrl,
  buttonLabel,
  handleButton,
  isSemiActive,
  isVideoCard,
  videoInfo,
  isInvertedColour,
}) => {
  const renderButton = () => {
    if (isVideoCard) {
      return <ContainerVideoThumb info={videoInfo} />;
    }
    if (isInvertedColour) {
      return (
        <ButtonInverted onClick={handleButton}>{buttonLabel}</ButtonInverted>
      );
    }
    return (
      <Button
        isSemiActive={isSemiActive}
        onClick={handleButton}
        isInvertedColour={isInvertedColour}>
        {buttonLabel}
      </Button>
    );
  };

  return (
    <Container isVideoCard={isVideoCard}>
      <ImageContainer>
        <Image src={imageUrl} alt="step-image" />
      </ImageContainer>
      <Left>
        <Title>
          {title}
          {isVideoCard && <PlayOutlineIcon />}
        </Title>
        <Description>{description}</Description>
      </Left>
      <Right>{renderButton()}</Right>
    </Container>
  );
};

StepBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  buttonLabel: PropTypes.string,
  handleButton: PropTypes.func.isRequired,
  isSemiActive: PropTypes.bool,
  isVideoCard: PropTypes.bool,
  videoInfo: PropTypes.object,
  isInvertedColour: PropTypes.bool,
};

export default StepBox;
